<template>
  <el-dialog
    title
    :visible.sync="dialogVisible"
    :modal="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="1260px"
    :append-to-body="true"
    class="gongsiku"
  >
    <div slot="title">
      <div style="border-left:3px solid #698CAD;padding-left:10px;font-size:14px">{{ notSearchCompany ? '勿推公司' :'公司库' }}</div>
    </div>
    <div>
      <div class="gongsiku-box">
        <el-row type="flex" align="middle">
          <el-col :span="15">
            <div style="display: inline-flex;align-items: center;">
              <div class="morandi-btn" style="font-size:12px;background:rgba(12, 138, 206, 0.5);" @click="gotoForecast">查看血库公司</div>
              <span style="display: inline-flex;align-items: center;margin-left:20px">
                <svg t="1665642751246" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4106" width="16" height="16"><path d="M999.722667 449.024C886.912 324.864 699.733333 193.621333 512 196.266667 324.266667 193.578667 137.088 324.906667 24.234667 449.024a94.336 94.336 0 0 0 0 125.781333C135.722667 697.642667 320.298667 827.733333 505.130667 827.733333h13.141333c185.472 0 369.962667-130.090667 481.578667-252.970666a94.293333 94.293333 0 0 0-0.128-125.738667zM315.733333 512a196.266667 196.266667 0 1 1 196.266667 196.266667A196.266667 196.266667 0 0 1 315.733333 512z" p-id="4107" fill="#F56C6C"></path><path d="M512 512m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z" p-id="4108" fill="#F56C6C"></path></svg>
                <span style="margin-left:2px">标志的为最近变动的血库</span>
              </span>
              <span style="display: inline-flex;align-items: center;margin-left:10px">
                <svg t="1665628893507" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2675" width="16" height="16"><path d="M512 960C265.6 960 64 758.4 64 512S265.6 64 512 64s448 201.6 448 448-201.6 448-448 448z m0-832C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384S723.2 128 512 128z" p-id="2676" fill="#ff9966"></path><path d="M512 800c-17.6 0-32-14.4-32-32V480c0-17.6 14.4-32 32-32s32 14.4 32 32v288c0 17.6-14.4 32-32 32z" p-id="2677" fill="#ff9966"></path><path d="M672 672H352c-17.6 0-32-14.4-32-32s14.4-32 32-32h320c17.6 0 32 14.4 32 32s-14.4 32-32 32zM672 512H352c-17.6 0-32-14.4-32-32s14.4-32 32-32h320c17.6 0 32 14.4 32 32s-14.4 32-32 32z" p-id="2678" fill="#ff9966"></path><path d="M512 512c-8 0-16-3.2-22.4-9.6l-158.4-158.4c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l158.4 158.4c12.8 12.8 12.8 32 0 44.8-6.4 6.4-14.4 9.6-22.4 9.6z" p-id="2679" fill="#ff9966"></path><path d="M512 512c-8 0-16-3.2-22.4-9.6-12.8-12.8-12.8-32 0-44.8l158.4-158.4c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8l-158.4 158.4c-6.4 6.4-14.4 9.6-22.4 9.6z" p-id="2680" fill="#ff9966"></path></svg>
                <span style="margin-left:2px">标志的为可能的大金主</span>
              </span>
            </div>
          </el-col>
          <el-col :span="9">
            <el-autocomplete
              v-model="searchResult"
              :fetch-suggestions="querySearch"
              prefix-icon="el-icon-search"
              size="mini"
              :trigger-on-focus="false"
              placeholder="输入公司名称"
            >
              <template slot-scope="{ item }">
                <div @click="selectResult(item)">
                  <div style="font-size:16px;color:#000">{{ item.简称 }}</div>
                  <div style="font-size:14px;color:#999999">
                    <span>{{ item.行业 }}</span
                    >/ <span>{{ item.平台等级 | formatPingtai }}</span
                    >/ <span>{{ item.简称 }}</span>
                  </div>
                </div>
              </template>
            </el-autocomplete>
          </el-col>
        </el-row>
      </div>
      <el-container style="height:50vh;padding-top:10px">
        <el-aside style="height:100%;overflow-y:auto;color:#666;font-size:12px" width="220px">
          <el-menu :default-active="curIndustry" :default-openeds="defaultOpeneds" @select="selectIndustries">
            <el-submenu v-for="(hang, da) in industryMap" :key="da" :index="da">
              <template slot="title">
                <span>{{da}}</span>
              </template>
              <el-menu-item v-for="item in hang" :key="item" :index="item">
                {{ item }}
                <el-badge v-if="industriesNum(item) !== 0" style="position:absolute;left:8px;top:-2px" :value="industriesNum(item)" />
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <div v-if="curIndustry" v-loading="loading" style="height:100%;width:100%;overflow-y:auto;" ref="tagsBox">
          <div v-if="options[defaultSearchField]" class="gongsiku-box gongsik-search" style="margin-bottom:10px">
            <div
              :style="{height:options[defaultSearchField].length>4&&showSearch1?'auto':'30px'}"
              style="display:flex;margin-bottom:10px;overflow:hidden;"
            >
              <div style="width:70px;color:#666;padding-top:5px;">{{defaultSearchField}}:</div>
              <div style="flex:1">
                <el-tag
                  v-for="(val, label) in options[defaultSearchField]"
                  :key="val"
                  size="small"
                  class="custom-tags"
                  :effect="searchType(defaultSearchField, val)"
                  @click="selectSearch(defaultSearchField, val)"
                  >{{ isNaN(label)?label:val }}</el-tag
                >
                <el-tag
                  size="small"
                  class="custom-tags"
                  :effect="searchType(defaultSearchField, null)"
                  @click="selectSearch(defaultSearchField, null)"
                  >其他</el-tag
                >
              </div>
              <div v-show="defaultSearchField=='平台'" class="morandi-btn-outline" @click="onlyXueKu=!onlyXueKu" style="font-size:12px">{{onlyXueKu?'取消筛选血库':'筛选血库'}}</div>
              <div v-if="options[defaultSearchField].length>4" style="width:100px;cursor:pointer;color:#AEC6DB;font-size:12px;line-height:28px;" @click="showSearch1=!showSearch1">
                <span v-if="showSearch1">收起<i class="el-icon-caret-top"></i></span>
                <span v-else>展开<i class="el-icon-caret-bottom"></i></span>
              </div>
            </div>
            <div
              v-if="searchData.子行业 && chanpin[searchData.子行业]"
              :style="{height:chanpin[searchData.子行业].length>5&&showSearch2?'auto':'30px'}"
              style="display:flex;margin-bottom:10px;overflow:hidden;"
            >
              <div style="width:70px;color:#666;padding-top:5px;">业务产品:</div>
              <div style="flex:1">
                <el-tag
                  v-for="(val, key) in chanpin[searchData.子行业]"
                  :key="key"
                  size="small"
                  class="custom-tags"
                  :effect="searchType('行业产品', val=='其他'?null:val, true)"
                  :closable="searchType('行业产品', val=='其他'?null:val, true) === 'dark'"
                  @close="removeSearch('行业产品', val=='其他'?null:val, true)"
                  @click="selectSearch('行业产品', val=='其他'?null:val, true)"
                  >{{ val }}</el-tag
                >
              </div>
              <div v-if="chanpin[searchData.子行业].length>5" style="width:100px;cursor:pointer;color:#AEC6DB;font-size:12px;line-height:28px;" @click="showSearch2=!showSearch2">
                <span v-if="showSearch2">收起<i class="el-icon-caret-top"></i></span>
                <span v-else>展开<i class="el-icon-caret-bottom"></i></span>
              </div>
            </div>
          </div>
          <div v-if="resultCompany.length === 0" style="text-align:center;padding-top:10px;color:#999">暂无相关数据~</div>
          <div v-else class="gongsiku-box" style="min-height:200px">
            <el-tag
              v-for="item in filteredCompany"
              :key="item._id"
              size="small"
              class="custom-tags"
              :effect="tagType(item.简称)"
              :closable="tagType(item.简称) === 'dark'"
              @close="removeCompany(item.简称)"
              @click="selectCompany(item)"
              >
              <div :title="item.简称">{{ item.简称 }}</div>
              <el-tooltip v-if="item.血库" placement="top" style="margin-right:5px">
                <div slot="content">
                  <pre style="max-width:300px;word-wrap:break-word;white-space:pre-wrap;line-height:1.5;">{{xuekuDetail(item)}}</pre>
                </div>
                <svg v-if="item.血库" t="1665642751246" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4106" width="16" height="16"><path d="M999.722667 449.024C886.912 324.864 699.733333 193.621333 512 196.266667 324.266667 193.578667 137.088 324.906667 24.234667 449.024a94.336 94.336 0 0 0 0 125.781333C135.722667 697.642667 320.298667 827.733333 505.130667 827.733333h13.141333c185.472 0 369.962667-130.090667 481.578667-252.970666a94.293333 94.293333 0 0 0-0.128-125.738667zM315.733333 512a196.266667 196.266667 0 1 1 196.266667 196.266667A196.266667 196.266667 0 0 1 315.733333 512z" p-id="4107" fill="#F56C6C"></path><path d="M512 512m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z" p-id="4108" fill="#F56C6C"></path></svg>
              </el-tooltip>
              <el-tooltip v-if="item.金主" placement="top" style="margin-right:5px">
                <div slot="content">
                  <pre style="max-width:300px;word-wrap:break-word;white-space:pre-wrap;line-height:1.5;">{{xuekuDetail(item)}}</pre>
                </div>
                <svg v-if="item.金主" style="margin-right:5px" t="1665628893507" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2675" width="16" height="16"><path d="M512 960C265.6 960 64 758.4 64 512S265.6 64 512 64s448 201.6 448 448-201.6 448-448 448z m0-832C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384S723.2 128 512 128z" p-id="2676" fill="#ff9966"></path><path d="M512 800c-17.6 0-32-14.4-32-32V480c0-17.6 14.4-32 32-32s32 14.4 32 32v288c0 17.6-14.4 32-32 32z" p-id="2677" fill="#ff9966"></path><path d="M672 672H352c-17.6 0-32-14.4-32-32s14.4-32 32-32h320c17.6 0 32 14.4 32 32s-14.4 32-32 32zM672 512H352c-17.6 0-32-14.4-32-32s14.4-32 32-32h320c17.6 0 32 14.4 32 32s-14.4 32-32 32z" p-id="2678" fill="#ff9966"></path><path d="M512 512c-8 0-16-3.2-22.4-9.6l-158.4-158.4c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l158.4 158.4c12.8 12.8 12.8 32 0 44.8-6.4 6.4-14.4 9.6-22.4 9.6z" p-id="2679" fill="#ff9966"></path><path d="M512 512c-8 0-16-3.2-22.4-9.6-12.8-12.8-12.8-32 0-44.8l158.4-158.4c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8l-158.4 158.4c-6.4 6.4-14.4 9.6-22.4 9.6z" p-id="2680" fill="#ff9966"></path></svg>
              </el-tooltip>
            </el-tag>
          </div>
        </div>
      </el-container>
    </div>
    <div slot="footer" style="background:#E6F4FC;border-radius:4px;height:40px;display:flex;justify-content:center;align-items:center;">
      <div style="color:#666">已选择 {{selectedCompany.length}} 家公司</div>
      <div class="morandi-btn" style="margin-left:10px" @click="submitData">确认</div>
      <div class="morandi-btn-outline" style="margin-left:10px" @click="cancel">取消</div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  filters: {
    formatPingtai(val) {
      const pingtai = {A:'大平台(A)', B:'中型平台(B)', C:'小平台(C)'}
      return val ? pingtai[val] : '其他平台'
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      loading: false,
      industryMap: {},
      defaultOpeneds: ['金融', '医药医疗'],
      selectedCompany: [],
      companyData: [],
      searchResult: '',
      curDaIndustry: '',
      curIndustry: '',
      resultCompany: [],
      from: '',
      notSearchCompany: false,
      options: {
        平台: {'大平台(A)': 'A', '中型平台(B)': 'B', '小平台(C)': 'C'},
        公司性质: ['国家政策性银行', '股份制', '城商行', '国有行', '外资行', '农商行'],
        投资阶段: ['种子期', '初创期', '成长期', '成熟期']
      },
      chanpin: {},
      defaultSearchField: null,
      fieldMap: {
        公募基金: '平台',
        证券: '平台',
        银行: '公司性质',
        '私募股权（PEVC）': '投资阶段',
      },
      searchData: {},
      onlyXueKu: false,
      showSearch1: false,
      showSearch2: false,
    }
  },
  watch: {
    curIndustry(val) {
      const searchData = {}
      this.chanpin = {}
      let field = null
      const hangye = app.industriesAll.find(i=>i.名称 == val)
      if (hangye && hangye.子行业) {
        field = '子行业'
        this.options['子行业'] = Object.keys(hangye.子行业)
        this.chanpin = hangye.子行业
      } else {
        field = this.fieldMap[val]
      }
      this.defaultSearchField = field
      if (field) {
        if (this.searchData[field]) {
          searchData[field] = this.searchData[field]
        } else {
          searchData[field] = field == '平台'?'A':this.options[field][0]
        }
      }
      this.searchData = searchData
      this.getCompany()
      this.$nextTick(()=>{
        if (this.$refs.tagsBox) this.$refs.tagsBox.scrollTop = 0
      })
    },
  },
  mounted() {
    const industryMap = {金融: [], 医药医疗: ['医药','医疗器械'], 芯片: []}
    app.industriesAll.forEach(i => {
      const da = i.大行业
      if (!industryMap[da]) industryMap[da] = []
      if (!industryMap[da].includes(i.名称)) industryMap[da].push(i.名称)
    })
    this.industryMap = industryMap
    this.loadAllCompany()
  },
  computed: {
    filteredCompany() {
      if (this.onlyXueKu && (this.curIndustry == '公募基金' || this.curIndustry == '证券')) {
        return this.resultCompany.filter(rc=>rc.血库)
      } else {
        return this.resultCompany
      }
    }
  },
  methods: {
    selectResult(item) {
      const searchField = this.fieldMap[item.行业]
      const val = searchField === '平台' ? item['平台等级'] : item[searchField]
      if (searchField) this.searchData[searchField] = Array.isArray(val)?val[0]:val
      this.selectedCompany.every(val => item.简称 !== val.简称) && this.selectedCompany.push(item)
      this.curIndustry = item.行业
      const hangye = app.industriesAll.find(i=>i.名称 == item.行业)
      if (hangye) this.curDaIndustry = hangye.大行业
    },
    selectIndustries(index, indexPath) {
      this.curIndustry = index
      this.curDaIndustry = indexPath[0]
    },
    async getCompany() {
      if (this.loading) return this.$message('正在加载请稍候')
      this.loading = true
      this.onlyXueKu = false
      const query = { 行业: { $in: [this.curIndustry] } }
      Object.keys(this.searchData).forEach(field=>{
        if (field == '平台') {
          query['平台等级'] = this.searchData['平台'] ? this.searchData['平台'] : {$in:['', null]}
        } else if (field == '行业产品') {
          if (this.searchData['行业产品'].includes(null)) {
            query['行业产品'] = { $in: this.searchData['行业产品'].concat('') }
          } else if (this.searchData['行业产品'].length > 0) {
            query['行业产品'] = { $in: this.searchData['行业产品'] }
          }
        } else {
          query[field] = Array.isArray(this.searchData[field]) ? {$in: this.searchData[field]} : this.searchData[field]
        }
      })
      const res = await window.app.service('company').getCompanySimpleList({ query, fields: { _id: 1,公司名称: 1,简称: 1,排名: 1,行业: 1,签约时间: 1,平台等级: 1,公司类型: 1,公司性质: 1,签约: 1 } })
      if (res.status == 'success') {
        const resultCompany = res.data
        if (this.defaultSearchField == '平台') {
          if (!this[`${this.curIndustry}金主`]) await this.initJinzhu()
          resultCompany.forEach(rc=> {
            const jinzhu = this[`${this.curIndustry}金主`].find(jz=>jz.简称 == rc.简称)
            if (jinzhu) {
              rc.金主 = jinzhu.金主
              rc.血库百分数 = jinzhu.血库百分数
              rc.金主百分数 = jinzhu.金主百分数
            }
            const xku = this[`${this.curIndustry}血库`].find(jz=>jz.简称 == rc.简称)
            if (xku) {
              rc.血库 = xku.血库
              rc.血库百分数 = xku.血库百分数
              rc.金主百分数 = xku.金主百分数
            }
          })
        }
        this.resultCompany = resultCompany
      }
      this.loading = false
    },
    tagType(name) {
      return this.selectedCompany.some(val => name === val.简称) ? 'dark' : 'plain'
    },
    industriesNum(industry) {
      return this.selectedCompany.filter(val => val.行业 === industry).length
    },
    open(defaultCompanies, onConfirm, notSearchCompany) {
      this.dialogVisible = true
      if (Array.isArray(defaultCompanies)) {
        this.selectedCompany = this.companyData.filter(v => defaultCompanies.includes(v.简称))
      }
      if (onConfirm) this.onConfirm = onConfirm
      this.notSearchCompany = notSearchCompany
      this.onlyXueKu = false
    },
    selectCompany(item) {
      this.selectedCompany.every(val => item.简称 !== val.简称)
        ? this.selectedCompany.push(item)
        : (this.selectedCompany = this.selectedCompany.filter(val => item.简称 !== val.简称))
    },
    removeCompany(item) {
      this.selectedCompany = this.selectedCompany.filter(val => item !== val.简称)
    },
    searchType(type, val, isArr) {
      if (!this.searchData[type]) return 'plain'
      if (isArr) return this.searchData[type].some(v => val === v) ? 'dark' : 'plain'
      return this.searchData[type] == val ? 'dark' : 'plain'
    },
    selectSearch(type, val, isArr) {
      if (isArr) {
        if (!this.searchData[type]) this.searchData[type] = []
        this.searchData[type].every(v => val !== v)
          ? this.searchData[type].push(val)
          : (this.searchData[type] = this.searchData[type].filter(v => val !== v))
      } else {
        this.searchData[type] = val
      }
      this.getCompany()
    },
    removeSearch(type, val) {
      this.searchData[type] = this.searchData[type].filter(v => val !== v)
      this.getCompany()
    },
    querySearch: async function(queryString, cb) {
      const list = this.companyData
      const results = queryString != null ? list.filter(this.createFilter(queryString)).slice(0, 10) : []
      return cb(results)
    },
    createFilter: function(queryString) {
      return company => company.简称 && company.简称.indexOf(queryString.toLowerCase()) === 0
    },
    loadAllCompany: async function() {
      const list = await app.service('company').getCompanySimpleList({ 
        fields: { _id: 1, 简称: 1, 公司名称: 1, 行业: 1, 平台等级: 1, 行业产品: 1, 公司性质: 1, 投资阶段: 1 }
      })
      this.companyData = list.data
    },
    submitData() {
      const submitData = this.selectedCompany.map(val => val.简称)
      if (submitData.length === 0) {
        this.$message({
          message: '请选择至少一家公司',
          type: 'warning',
        })
        return
      }
      this.$emit('confirm', submitData)
      this.onConfirm && this.onConfirm(submitData)
      this.dialogVisible = false
      this.selectedCompany = []
    },
    cancel() {
      this.dialogVisible = false
      this.selectedCompany = []
    },
    gotoForecast() {
      window.open(`${window.origin}/#/forecast`, '_blank')
    },
    async initJinzhu() {
      const query = {
        行业: this.curIndustry,
      }
      const { data } = await app.service('company').getCompanySituation(query)
      const 金主 = []
      const 血库 = []
      for (let dt of data) {
        let xuekuScore = 1
        let jinzhuScore = 1
        let sum = 40
        const companyInfo = dt.companyInfos && dt.companyInfos[0]
        Object.keys(dt.血库).forEach((xk) => {
          xuekuScore *= dt.血库[xk].标准分
        })
        Object.keys(dt.金主).forEach((jz) => {
          jinzhuScore *= dt.金主[jz].标准分
        })
        let jinzhuBaifenshu = (jinzhuScore / sum).toFixed(4) * 100
        let xuekuScoreBaifenshu = (xuekuScore / sum).toFixed(4) * 100
        dt.显示百分数 = Math.max(jinzhuBaifenshu, xuekuScoreBaifenshu)
        if (dt.显示百分数 < 60) continue
        dt.金主百分数 = jinzhuBaifenshu
        dt.血库百分数 = xuekuScoreBaifenshu
        if (companyInfo) {
          dt.显示百分数 = companyInfo.可信程度 * 100
          if (companyInfo.类别 === '金主') {
            dt.金主百分数 = dt.显示百分数
          } else {
            dt.血库百分数 = dt.显示百分数
          }
        }
        dt.总部办公地 = dt.总部办公地 || '其他'
        dt.整体规模排名 = dt.整体规模排名 || 9999
        dt.行业排名 = dt.排名 || 9999
        dt.流入排名 = dt.流入排名 || 9999
        dt.流出排名 = dt.流出排名 || 9999
        dt.总部办公地 = dt.总部办公地 || '其他'
        dt.平台等级 = dt.平台等级 || ''
        dt.固定薪酬 = dt.固定薪酬 || ''
        dt.激励机制 = dt.激励机制 || ''
        dt.人员受认可度 = dt.人员受认可度 || ''
        dt.人员稳定性 = dt.人员稳定性 || ''
        dt.公司人数 = dt.公司人数 || 0
        dt.简称 = dt.简称 || ''
        if (dt.血库百分数 >= dt.金主百分数) {
          血库.push(dt)
        } else {
          金主.push(dt)
        }
      }
      this[`${this.curIndustry}金主`] = JSON.parse(JSON.stringify(金主))
      this[`${this.curIndustry}血库`] = JSON.parse(JSON.stringify(血库))
    },
    xuekuDetail(company) {
      let 情报类别 = [
        '地点变化',
        '高管变动',
        '政策/监管',
        '业务踩雷',
        '业务下降',
        '市场变化',
        '薪酬因素',
        '股东因素',
        '公司裁员',
        '招聘信息',
      ]
      let 血库 = []
      let 血库情报 = []
      let 金主 = []
      let 金主情报 = []
      if (company.血库) {
        血库 = (company.血库.人员市场认可度?company.血库.人员市场认可度.content:[]).concat(company.血库.人员离职?company.血库.人员离职.content:[])
        血库情报 = 血库
          .map((e) => {
            return 情报类别.includes(e.类别) && e.data && e.data.变动影响程度或岗位类型 && e.分值
              ? [parseInt(e.data.变动影响程度或岗位类型.split('-')[0]), e.data.详情]
              : e.data
              ? [0, e.data.详情]
              : null
          })
          .filter(Boolean)
          .sort((a, b) => parseInt(b[0]) - parseInt(a[0]))
      }
      if (company.金主) {
        金主 = (company.金主.公司口碑?company.金主.公司口碑.content:[]).concat(company.金主.公司缺人?company.金主.公司缺人.content:[])
        金主情报 = 金主
          .map((e) => {
            return 情报类别.includes(e.类别) && e.data && e.data.变动影响程度或岗位类型 && e.分值
              ? [parseInt(e.data.变动影响程度或岗位类型.split('-')[0]), e.data.详情]
              : e.data
              ? [0, e.data.详情]
              : null
          })
          .filter(Boolean)
          .sort((a, b) => parseInt(b[0]) - parseInt(a[0]))
      }
        let text = ''
        if (company.金主百分数 > company.血库百分数 && 金主情报.length) {
          text = `【情报】【金主】${金主情报.length ? 金主情报[0][1] || '暂无情报' : '暂无情报'}`
        } else {
          text = `【情报】【血库】${血库情报.length ? 血库情报[0][1] || '暂无情报' : '暂无情报'}`
        }
        return `${company.简称} (金主：${company.金主百分数}%，血库：${company.血库百分数}%)\n${text}`
    }
  },
}
</script>
<style scoped src="../../statistics/css/hunting.css"></style>
<style scoped>
.custom-tags {
  color: #303133;
  margin: 3px 5px;
  cursor:pointer;
  border:none;
  font-size:12px;
  width:18%;
  display:inline-flex;
  justify-content:space-between;
  align-items:center
}
.custom-tags.el-tag--dark {
  color: #fff;
  background-color: #0C8BCE;
}
.custom-tags.el-tag--dark:hover {
  color: #fff;
  background-color: #0C8BCE;
}
.gongsik-search .custom-tags.el-tag--dark {
  background-color:rgba(12, 138, 206, 0.5);
}
.gongsik-search .custom-tags.el-tag--dark:hover {
  background-color:rgba(12, 138, 206, 0.5)
}
.custom-tags div {
  flex: 1;
  overflow: hidden;
}
.custom-tags svg {
  flex: none;
}
.custom-tags.el-tag--dark .el-icon-close{
  flex: none;
}
.custom-tags:hover {
  color: #409eff;
}
.gongsiku-box {
  border:1px solid #eee;
  border-radius:4px;
  padding:8px 15px;
}
</style>
<style>
  .gongsiku .el-header .el-input__inner {
    border-radius: 14px;
  }
  .gongsiku .el-submenu .el-menu-item {
    height: 30px;
    line-height: 30px;
  }
  .gongsiku .el-submenu .el-submenu__title {
    background: #E6F4FC;
    height: 30px;
    line-height: 30px;
    border-bottom: 1px solid #fff;
  }
  .gongsiku .el-menu-item.is-active {
    background: #F1F8FE;
  }
  .gongsiku .el-dialog__body {
    padding: 10px 20px;
  }
</style>
